import Vue from 'vue'

let bus = null

function getVueBus() {
  if (!bus) {
    bus = new Vue()
  }
  return bus
}

export const EventTypes = {
  LOGOUT_EVENT: 'LOGOUT_EVENT',
  NewNotification: 'NewNotification',
  NotificationClick: 'NotificationClick',
  NewLive: 'NewLive',
  MeterImportCompleted: 'MeterImportCompleted',
  BankReconciliationImportCompleted: 'BankReconciliationImportCompleted',
  FxOverLimitApplied: 'FxOverLimitApplied',
  Tab_Close: 'Tab_Close',
  Sys_Task_New: 'Sys_Task_New',
  RefreshSeat: 'RefreshSeat',
  CashOutMonitor_STATUS_CHANGE: 'CashOutMonitor_STATUS_CHANGE',
  Coupon_Refresh: 'Coupon_Refresh'
}

export function addEventListener(event, fn) {
  getVueBus().$on(event, fn)
}
export function removeEventListener(event, fn) {
  getVueBus().$off(event, fn)
}
export function emitEvent(event, data) {
  getVueBus().$emit(event, data)
}
